export default __webpack_public_path__ + "static/media/admin.d864002a.png";